module.exports = __webpack_public_path__ + "a10135a44e6b1115624ea202f0a6ac56.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 408
// module chunks = 0